// extracted by mini-css-extract-plugin
export default {"slider_list":"City_slider_list__63VGx","item_container":"City_item_container__-3UGZ","active":"City_active__mv7sK"};